



































































































































































import { PropType } from 'vue';
import { defineComponent, watch, toRefs, ref, nextTick, computed } from '@vue/composition-api';
import {
  AdgroupFormData,
  CampaignFormData,
  NodeHoverContentType,
  InterestBehaviorScene,
  CreateMode,
} from '@tt4b/ttam-enums';
import { cloneDeep } from 'lodash-es';
import { useInterestBehavior } from '../hooks';
import TreeNodeHoverEstiamte from '@/components/common/tree-node-hover-estimate/index.vue';
import SimilarRecommend from '../components/similar-recommend.vue';
import { trackEvent, setGameBadgeStorage } from './../../../../utils/index';
import { selectOneSimilarRecommend } from '../hooks/use-interest-behavior';
import { exposure } from 'byted-vui/src/directives/exposure';
import { i18n } from './../../../../i18n';
import { useAdgroupInterestsValidate } from '@tt4b/ttam-hooks';
const { HASHTAG, KEYWORD } = InterestBehaviorScene;
const searchTagDisabledHoverTipKey = {
  [HASHTAG]: 'adgroup_hashtag_disabled_tips',
  [KEYWORD]: 'adgroup_interest_keywords_disabled_tips',
};
const name = 'ttam-interests-search-box-five-in-one-compose';
export default defineComponent({
  name,
  components: {
    TreeNodeHoverEstiamte,
    SimilarRecommend,
  },
  directives: { exposure },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
  },
  // eslint-disable-next-line max-lines-per-function
  setup(props, { emit }) {
    const { adgroupData, campaignData } = toRefs(props);
    const interestSearchBoxRef = ref();
    const {
      panelData,
      treeTips,
      isShowTreeTips,
      onTabChange,
      checkIsHideBadge,
      isGameLabelTop,
      onSelectedChange,
      scrollbarWrap,
      tagsList,
      selectedTags,
      onTagClose,
      search,
      isSearching,
      searchKeyword,
      searchList,
      onSearchKeywordChange,
      onHideSearchResultList,
      onExposeResultListItem,
      afterClickResultListItem,
      onSelectTreeInteraction,
      subscribeFuzzySearch,
      isLimitU18Interest,
      handleTagDisabled,
      selectTreeRef,
      limitU18InterestSelectedTags,
      removeU18LimitTags,
    } = useInterestBehavior({
      campaignData,
      adgroupData,
      emit,
    });
    const { interestsValidate } = useAdgroupInterestsValidate({
      campaignFormData: campaignData,
      adgroupFormData: adgroupData,
    });
    const similarRecommendRef = ref();
    const treeProps = ref({ label: 'tag_name' });
    const nodeHoverContentNode = ref();
    // 受众预估type
    const nodeHoverContentNodeType = ref('');
    subscribeFuzzySearch();
    // 鼠标移入node的处理函数
    function onMouseEnterNode(data) {
      const hoverNodeData = cloneDeep(data?.data ?? {});
      hoverNodeData.id = hoverNodeData.tag_id;
      nodeHoverContentNodeType.value = NodeHoverContentType[hoverNodeData.scene];
      // 搜索
      if (isLimitU18Interest.value && searchList.value.length && handleTagDisabled(hoverNodeData)) {
        hoverNodeData.disabled = true;
      }
      nextTick(() => {
        nodeHoverContentNode.value?.showHoverEstimate(hoverNodeData);
      });
    }
    // 展示
    function handleTreeShow() {
      const adgroupId = adgroupData.value?.adId || '';
      trackEvent('creat_campaign_targeting_searchbox_taxonomy_impression', { adgroup_id: adgroupId });
      if (isGameLabelTop.value) {
        setGameBadgeStorage(false);
      }
    }
    const changeInterests = function (data: any) {
      emit('change', data);
    };
    const isShowSimilarRecommend = computed(() => Boolean(similarRecommendRef.value?.isShowSimilarRecommend));
    const handleHoverTagDisabled = data => {
      if (!data?.data?.scene) {
        return '';
      }
      const scene = data?.data?.scene;
      return i18n.t(searchTagDisabledHoverTipKey[scene]);
    };
    // u18 受限的tags name
    const limitU18InterestSelectedTagsName = computed(() =>
      limitU18InterestSelectedTags.value?.map(v => v.tag_name).join(', '),
    );
    // 搜索结果中受限类型tag hover提示增加alert
    const showLimitU18InterestSearchNodeHoverAlert = data =>
      isLimitU18Interest.value && searchList.value.length && data?.data?.disabled;

    watch(
      () => limitU18InterestSelectedTags.value.length,
      (newVal, oldVal) => {
        // 非法兴趣标签都清掉后，手动触发一下表单校验
        if (Boolean(oldVal) && !newVal) {
          interestSearchBoxRef?.value?.clearValidate();
        }
      },
    );

    return {
      name,
      panelData,
      treeTips,
      isShowTreeTips,
      onTabChange,
      checkIsHideBadge,
      treeProps,
      nodeHoverContentNode,
      nodeHoverContentNodeType,
      onMouseEnterNode,
      handleTreeShow,
      selectedTags,
      onSelectedChange,
      scrollbarWrap,
      tagsList,
      onTagClose,
      changeInterests,
      selectOneSimilarRecommend,
      similarRecommendRef,
      isShowSimilarRecommend,
      search,
      isSearching,
      searchKeyword,
      searchList,
      onSearchKeywordChange,
      onHideSearchResultList,
      onExposeResultListItem,
      afterClickResultListItem,
      onSelectTreeInteraction,
      subscribeFuzzySearch,
      isLimitU18Interest,
      HASHTAG,
      KEYWORD,
      handleTagDisabled,
      handleHoverTagDisabled,
      selectTreeRef,
      limitU18InterestSelectedTags,
      interestSearchBoxRef,
      removeU18LimitTags,
      interestsValidate,
      limitU18InterestSelectedTagsName,
      showLimitU18InterestSearchNodeHoverAlert,
    };
  },
});
